import React from 'react'

import { StatusBadge } from '@driftt/dds'

import { bucketEngagementScore } from './utils'

const EngagementScoreSimplified = ({ score }: { score: number | undefined }) => {
  const bucketedScore = bucketEngagementScore(score)
  let fitStyle: 'inactive' | 'error' | 'warning' | 'success' | 'pending'
  switch (bucketedScore) {
    case 'Unknown':
      fitStyle = 'inactive'
      break
    case 'Not engaged':
      fitStyle = 'error'
      break
    case 'Somewhat engaged':
    case 'Engaged':
      fitStyle = 'warning'
      break
    default:
      fitStyle = 'success'
  }

  return (
    <StatusBadge variant={fitStyle} size="medium">
      {bucketedScore}
    </StatusBadge>
  )
}

export default EngagementScoreSimplified
